import { useEffect } from 'react';

import { useTrackingContext } from '@tracking/Provider/Context';
import { useTrackSignupBasketPanelDisplayedOnce } from '@tracking/trackingEvents';

const useBasketTracking = (enabled = false) => {
  const trackBasketPanelDisplayed = useTrackSignupBasketPanelDisplayedOnce();
  const { trackingContexts } = useTrackingContext();

  useEffect(() => {
    if (!enabled) {
      return;
    }

    trackBasketPanelDisplayed(
      {},
      {
        contexts: trackingContexts,
      }
    );
  }, [enabled, trackBasketPanelDisplayed, trackingContexts]);
};

export { useBasketTracking };
